var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useResourceContext } from 'react-admin';
import { useGetLocks } from '../dataProvider/useGetLocks';
import { useSubscribeToLocks } from './useSubscribeToLocks';
/**
 * Fetch the locks for the current resource, with live updates
 *
 * Calls `dataProvider.getLocks()` for the current resource on mount,
 * and subscribes to live updates on the `lock/[resource]` topic.
 * This means that if a lock is acquired or released by another user
 * while the current user is on the page, the return value will be updated.
 *
 * @example
 * import { List, useRecordContext } from 'react-admin';
 * import LockIcon from "@mui/icons-material/Lock";
 * import { useGetLocksLive } from '@react-admin/ra-realtime';
 *
 * const LockField = ({ locks }) => {
 *    const record = useRecordContext();
 *    if (!record) return null;
 *    const lock = locks.find(lock => lock.recordId === record?.id);
 *    if (!lock) return null;
 *    return <LockIcon />;
 * };
 *
 * const PostList = () => {
 *   const { locks } = useGetLocksLive();
 *   return (
 *     <List>
 *       <Datagrid>
 *         <TextField source="title" />
 *         <LockField locks={locks} />
 *       </Datagrid>
 *     </List>
 *   );
 * };
 */
export var useGetLocksLive = function (resourceParam, params, options) {
    var resource = useResourceContext({ resource: resourceParam });
    var _a = options || {}, onEventReceived = _a.onEventReceived, queryOptions = __rest(_a, ["onEventReceived"]);
    var response = useGetLocks(resource, params, queryOptions);
    var refetch = response.refetch;
    var defaultCallback = React.useCallback(function () {
        refetch();
    }, [refetch]);
    useSubscribeToLocks(onEventReceived || defaultCallback, resource);
    return response;
};
